import Siema from '../../../js/vendor/siema';
import { Helper } from '../../../js/util/helper';

export default class Icons {
  constructor( node ) {
    this.node = node;
  }
}
